import { screenSizeDetector } from '@/next/utils/screenSizeDetector';
import { DesktopDrawContextMenu } from './DesktopDrawContextMenu';
import { MobileDrawContextMenu } from './MobileDrawContextMenu';

interface DrawContextMenuProps {
  doneOnClick: () => void;
  undoOnClick: () => void;
  trashOnClick: () => void;
  closeOnClick: () => void;
  canClose: boolean;
  cancelOnClick: () => void;
}

export const DrawContextMenu = (props: DrawContextMenuProps) => {
  const isMobile = screenSizeDetector.useIsMobile();

  if (isMobile) {
    return <MobileDrawContextMenu {...props} />;
  }

  return <DesktopDrawContextMenu {...props} />;
};
